// src/components/WhatsAppButton.jsx

import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './WhatsAppButton.css'; // We will create this CSS file next

const WhatsAppButton = () => {
  // --- 1. CONFIGURE YOUR DETAILS HERE ---
  const phoneNumber = "919537222200"; // Use your full number in international format
  const defaultMessage = "Hello! I saw your website and I'm interested in your products.";

  // --- 2. CREATE THE WHATSAPP URL ---
  // The encodeURIComponent function formats the message correctly for the URL
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;

  return (
    <a
      href={whatsappUrl}
      className="whatsapp-float"
      target="_blank" // Opens in a new tab
      rel="noopener noreferrer" // Security best practice
      aria-label="Chat with us on WhatsApp"
    >
      <FaWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppButton;